import styled from 'styled-components';

export const CyprusTabWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  margin-left: 16px;
  margin-right: 16px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: fit-content;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    background-color: transparent;
  }
`;
export const CyprusTabResponsiveContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  width: 100%;
  padding-top: 16px;
`;
export const Text = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.Blue600};
  font-size: 12px;
  padding: 0 8px;
`;

export const ErrorModalBody = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  gap: 30px;
`;

export const ErrorModalButton = styled.div`
  cursor: pointer;
  display: flex;
  width: 155px;
  padding: 11px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.D400};
  background-color: ${({ theme }) => theme.palette.white};
`;

export const PackageContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.lynxWhite};
`;
